@if (formControl) {
  <div class="control-input-with-buttons">
    <mat-form-field class="control-input">
      <mat-label>{{ label }}</mat-label>
      <input
        [formControl]="formControl"
        [min]="minValue"
        [max]="maxValue"
        (blur)="onBlur()"
        matInput
        [id]="id()"
        [name]="name()"
        [owlDateTime]="dateTimePicker"
        [owlDateTimeTrigger]="dateTimePicker"
        [style]="textAlignStyle()" />
        <owl-date-time #dateTimePicker
          pickerType="both"
          [firstDayOfWeek]="firstDayOfWeek()"
          [stepMinute]="stepMinute()"
          [startAt]="minDate()"
          [endAt]="maxDate()"
          (blur)="onBlur()" />
        @if (!formControl.disabled) {
          <button
            type="button"
            tabindex="-1"
            matSuffix
            mat-icon-button
            (click)="clear()"
            class="action-button visible-on-edit-mode">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  }
  <app-control-error [control]="formControl" [offset]="-16" />
